import { render, staticRenderFns } from "./NewBlockAction.vue?vue&type=template&id=161d9bcb&"
import script from "./NewBlockAction.vue?vue&type=script&lang=js&"
export * from "./NewBlockAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports